'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tool = void 0;
var $ = require("jquery");
var Tool = /** @class */ (function () {
    function Tool() {
        this.browserWidth = 0;
        var self = this;
        $('.trigToolIcon').on('click', function (e) {
            var name = $(e.currentTarget).attr('data-name');
            var position = $(".paramToolIcon[data-name=" + name + "]").position().left;
            $('.bulletToolTop').animate({
                'left': -position
            });
        });
        $('.trigToolBack').on('click', function (e) {
            $('.bulletToolTop').animate({
                'left': 0
            });
        });
        window.addEventListener("load", function () {
            self.browserWidth = $(window).width();
        });
        window.addEventListener("resize", function () {
            var newBrowserWidth = $(window).width();
            if (self.browserWidth !== newBrowserWidth) {
                $('.bulletToolTop').css({
                    'left': 0
                });
            }
        });
    }
    return Tool;
}());
exports.Tool = Tool;
exports.default = Tool;
